import { Navigate } from "react-router-dom";
import { ROUTES } from "../../../routes";

/**
 * Legacy URL `/auth/card/terms` redirects to the current disclosures & agreement page.
 */
const CardTerms = () => (
  <Navigate to={ROUTES.CARD_DISCLOSURES_AGREEMENT} replace />
);

export default CardTerms;
